import React, {useContext, useEffect, useState} from 'react'
import {Button, Input, InputNumber, Select, Table, Upload, Space, Modal, message, Progress, Card, Typography, Popconfirm} from "antd";
import {SaveOutlined, UploadOutlined, ThunderboltOutlined, ExperimentOutlined} from "@ant-design/icons";
import {useDispatch, connect} from "react-redux";
import Papa from 'papaparse';
import {getRandomColor} from "../../util/shared_functions";
import ManyosSpinner from "../../ManyosSpinner/ManyosSpinner";
import {getModels, getTrainingDataFile, getTrainingDataList, saveTrainingData, smileConcealAPIcall} from "../../util/redux/asyncActions";
import {setActiveTag} from "../../util/redux";
import TextField from '../../TextField/TextField'
import Tag from '../../Tag/Tag'
import {AuthContext} from "../../Auth/AuthProvider";

const {Text} = Typography;
const {Option} = Select;
const {Dragger} = Upload


const select = state => {
    const {loading, trainingData, files, tags, activeTag} = state.request
    return {loading, trainingData, files, tags, activeTag}
}


function PrepData(props) {

    const {loading, trainingData, files, tags, activeTag} = props
    const [file, setFile] = useState(null);
    const [filterResults, setFilterResults] = useState(true)
    const [data, setData] = useState([]);
    const [selectedColumn, setSelectedColumn] = useState('');
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [tagList, setTagList] = useState([]);
    const [downloadData, setDownloadData] = useState();
    const [refreshStat, setRefreshStat] = useState(false);
    const [tfilename, settFilename] = useState()
    const [tagFilter, setTagFilter] = useState('')
    const [autoTagging, setAutoTagging] = useState(false);
    const [autoTagProgress, setAutoTagProgress] = useState(null);
    const [genLang, setGenLang] = useState("de");
    const [genCount, setGenCount] = useState(200);
    const [genDescription, setGenDescription] = useState("");
    const [genModel, setGenModel] = useState("");
    const [llmModels, setLlmModels] = useState([]);

    useEffect(() => {
        smileConcealAPIcall({
            url: `${window._env_.REACT_APP_API_URL}/llmModels`,
            requestOptions: {method: "GET", headers: {"content-type": "application/json"}},
            userManager
        }).then((r) => setLlmModels((r && r.models) || []))
          .catch(() => setLlmModels([]));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [generating, setGenerating] = useState(false);
    const dispatch = useDispatch();
    const userManager = useContext(AuthContext);

    const [stat, setStat] = useState({
        numberOfTags: 0,
        rows: 0,
        tags: []
    });
    useEffect(() => {
        dispatch(getTrainingDataList({userManager}))
    }, [])
    React.useEffect(() => {
        if (trainingData && trainingData != "") {

            try {
                const tData = JSON.parse(trainingData)
                setData(tData)

                setSelectedColumn(Object.keys(tData[0])[0]);
                setTagList(getTags(tData))
            } catch (e) {
                message.error(e.toString())
            }

        }

    }, [trainingData])
    React.useEffect(() => {
        console.log(data)

    }, [data])
    React.useEffect(() => {

        const allTags = []
        const rows = data.length
        data.forEach(row => {

            if (row.tags) {
                {
                    row.tags.forEach(tag => {

                        if (allTags.indexOf(tag.tag) < 0) {
                            allTags.push(tag.tag)
                        }

                    })
                }
            }
        })
        const untaggedRows = data.filter(row => !row.tags || row.tags.length === 0).length
        const taggedRows = data.filter(row => row.tags && row.tags.length > 0).length
        const tagStat = allTags.map(tag => {
            let i = 0
            data.forEach(row => {
                if (row.tags) {
                    i = i + row.tags.filter(rtag => rtag.tag === tag).length
                }
            })
            return {
                [tag]: {
                    rowsContaining: data.filter(row => {
                        return row.tags && row.tags.filter(rtag => rtag.tag === tag).length > 0
                    }).length,
                    totalCount: i


                }
            }
        })
        const newStat = {
            rows, untaggedRows, taggedRows,
            numberOfTags: allTags.length,
            tags: tagStat
        }

        setStat(newStat)

    }, [refreshStat])



    function getTags(content) {
        let allTags = tagList || []

        content.forEach(row => {

            if (row.tags && Array.isArray(row.tags)) {
                {

                    row.tags.forEach(tag => {

                        if (allTags.filter(rtag => tag.tag === rtag.tag).length === 0) {
                            allTags.push({tag: tag.tag.toUpperCase(), color: getRandomColor()})
                        }

                    })
                }
            }
        })

        return allTags
    }

    const handleFileUpload = (file) => {
        setFile(file);

        const reader = new FileReader();
        reader.addEventListener('load', (event) => {

            try {
                let content = JSON.parse(event.target.result)

                setData(content)

                setSelectedColumn(Object.keys(content[0])[0]);
                setTagList(getTags(content))
            } catch (e) {

                Papa.parse(file, {
                    header: true,
                    complete: (result) => {

                        setData(result.data);
                        setSelectedColumn(Object.keys(result.data[0])[0]);
                        setTagList(getTags(result.data))
                    },
                    error: (error) => {
                        console.log(error);

                    }
                });
            }

        });

        reader.readAsText(file);
    };


    const onSelectChange = (newSelectedRowKeys) => {

        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };
    const handleColumnSelect = (value) => {
        setSelectedColumn(value);
    };

    const hasSelected = selectedRowKeys.length > 0;

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
    };

    const columns = data.length > 0
        ?

        [...Object.keys(data[0]).filter(colName => colName == selectedColumn).map((colName) => {
            return {
                title: colName,
                dataIndex: colName,
                key: colName,
                render: (text, record, rowIndex) => {
                    return (


                        <TextField
                            key={`textfield-${rowIndex}`}
                            value={text}
                            tags={data[record.key].tags}
                            setTagList={setTagList}
                            tagList={tagList}
                            onChange={(tags) => {

                                const newData = [...data];

                                newData[record.key].tags = tags;

                                setData(newData);
                            }}

                        />

                    );
                }
            };
        })]
        : [];

    React.useEffect(() => {
        setFilteredData(data.filter((row) => {
            const regex = new RegExp(searchQuery, 'gi');
            return regex.test(row[selectedColumn]);
        }))
    }, [filterResults, data])

    const tableData = filteredData.map((row, rowIndex) => {
        const rowObj = {
            key: rowIndex,
            ...row

        };
        if (!rowObj.tags) {
            rowObj.tags = ""
        }

        return rowObj;
    });

    const handleFileSelect = (file) => {
        settFilename(file)
        dispatch(getTrainingDataFile({file, userManager}))
    }

    // Pseudo-labeling: pre-annotate rows via /analyzeText
    // (GLiNER + Privacy Filter + Trained Tagging, i.e. the saved config)
    const autoTagRows = async () => {
        // selected rows win; otherwise all rows without tags
        let targetIndices;
        if (selectedRowKeys.length > 0) {
            targetIndices = selectedRowKeys
                .map((key) => data.indexOf(filteredData[key]))
                .filter((i) => i >= 0);
        } else {
            targetIndices = data
                .map((row, i) => (!row.tags || row.tags.length === 0) ? i : -1)
                .filter((i) => i >= 0);
        }
        if (targetIndices.length === 0) {
            message.info("Nothing to auto-tag - select rows or add untagged data.");
            return;
        }

        setAutoTagging(true);
        setAutoTagProgress(0);
        const newData = [...data];
        let done = 0;
        try {
            for (const idx of targetIndices) {
                const text = newData[idx][selectedColumn];
                if (text && String(text).trim()) {
                    const response = await smileConcealAPIcall({
                        url: `${window._env_.REACT_APP_API_URL}/analyzeText`,
                        requestOptions: {
                            method: "POST",
                            headers: {"content-type": "application/json"},
                            body: JSON.stringify({text: String(text)})
                        },
                        userManager
                    });
                    const analysis = (response && response.analysis) || [];
                    // resolve overlaps: earliest start, then longer span, then higher score
                    const sorted = [...analysis].sort((a, b) =>
                        a.start - b.start ||
                        (b.end - b.start) - (a.end - a.start) ||
                        (b.score || 0) - (a.score || 0));
                    const chosen = [];
                    let lastEnd = -1;
                    for (const span of sorted) {
                        if (span.start >= lastEnd) {
                            chosen.push(span);
                            lastEnd = span.end;
                        }
                    }
                    newData[idx] = {
                        ...newData[idx],
                        tags: chosen.map((span) => ({start: span.start, end: span.end, tag: span.type}))
                    };
                }
                done++;
                setAutoTagProgress(Math.round((done / targetIndices.length) * 100));
                setData([...newData]);
            }
            setTagList(getTags(newData));
            setRefreshStat((r) => !r);
            message.success(`${targetIndices.length} rows pre-annotated - please review the tags.`);
        } catch (e) {
            message.error("Auto-tagging failed: " + e);
        }
        setAutoTagging(false);
        setAutoTagProgress(null);
    }

    // Showcase: generate synthetic, pre-tagged ITSM training data server-side
    // and load it through the normal file flow.
    const generateDemoData = async () => {
        setGenerating(true);
        try {
            const response = await smileConcealAPIcall({
                url: `${window._env_.REACT_APP_API_URL}/generateTrainingData`,
                requestOptions: {
                    method: "POST",
                    headers: {"content-type": "application/json"},
                    body: JSON.stringify({
                        lang: genLang,
                        count: genCount,
                        description: genDescription && genDescription.trim() ? genDescription.trim() : undefined,
                        model: genModel && genDescription && genDescription.trim() ? genModel : undefined
                    })
                },
                userManager
            });
            // NOTE: smileConcealAPIcall strips the "status" field from responses
            if (response && response.filename) {
                if (response.generatedTemplates) {
                    message.success(`LLM created ${response.generatedTemplates.length} templates for your description`);
                }
                message.success(`${response.count} pre-tagged examples generated (${response.filename})`);
                dispatch(getTrainingDataList({userManager}));
                handleFileSelect(response.filename);
            } else {
                message.error("Generation failed: " + ((response && response.error) || "unknown error"));
            }
        } catch (e) {
            message.error("Generation failed: " + e);
        }
        setGenerating(false);
    }

    let filename = "taggedData.json"
    let contentType = "application/json;charset=utf-8;";

    const prepStepIndex = data.length === 0 ? 0 : (stat.taggedRows > 0 ? 2 : 1);

    return (
        <div style={{maxWidth: 1100, margin: "0 auto"}}>
            <ManyosSpinner spinning={loading}>

                {(!file && (!trainingData || trainingData.length == 0))
                    ? (
                        <div className="sc-panel" style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 300px",
                            gap: 20,
                            alignItems: "start",
                        }}>
                            <Dragger
                                beforeUpload={handleFileUpload}
                                style={{borderRadius: 8}}
                            >
                                <p className="ant-upload-drag-icon">
                                    <UploadOutlined/>
                                </p>
                                <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                <p className="ant-upload-hint">
                                    Support for a SMILEconceal JSON File or Standard CSV File.
                                </p>
                            </Dragger>
                            <div style={{display: "flex", flexDirection: "column", gap: 16}}>
                                <Card size="small" title="Existing Files">
                                    <Select
                                        style={{width: "100%"}}
                                        placeholder="Select a file..."
                                        value={tfilename}
                                        onSelect={handleFileSelect}
                                        options={files.map((file, i) => {
                                            const f = typeof file === "string" ? {name: file} : file;
                                            return {
                                                key: `file-${i}`,
                                                value: f.name,
                                                label: f.modified
                                                    ? `${f.name}  ·  ${new Date(f.modified * 1000).toLocaleString([], {day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit"})}`
                                                    : f.name
                                            };
                                        })}
                                    />
                                </Card>
                                <Card size="small" title="Generate Training Data">
                                    <Space direction="vertical" style={{width: "100%"}}>
                                        <Select
                                            value={genLang}
                                            onChange={setGenLang}
                                            style={{width: "100%"}}
                                            options={[
                                                {value: "de", label: "Deutsch"},
                                                {value: "en", label: "English"}
                                            ]}
                                        />
                                        <InputNumber
                                            min={10}
                                            max={5000}
                                            value={genCount}
                                            onChange={setGenCount}
                                            style={{width: "100%"}}
                                            addonAfter="rows"
                                        />
                                        <Input.TextArea
                                            value={genDescription}
                                            onChange={(e) => setGenDescription(e.target.value)}
                                            placeholder="Optional: describe the data you need, e.g. 'Versicherungs-Servicedesk: Schadenmeldungen mit Policennummern, Auszahlungsbeträgen und IBANs' — an LLM will write matching templates."
                                            autoSize={{minRows: 3, maxRows: 6}}
                                        />
                                        {llmModels.length > 0 && genDescription.trim() && (
                                            <Select
                                                value={genModel || undefined}
                                                onChange={(v) => setGenModel(v || "")}
                                                allowClear
                                                style={{width: "100%"}}
                                                placeholder="LLM model (gateway default)"
                                                options={llmModels.map((m) => ({value: m, label: m}))}
                                                aria-label="LLM model for template generation"
                                            />
                                        )}
                                        <Button
                                            type="primary"
                                            icon={<ExperimentOutlined/>}
                                            loading={generating}
                                            onClick={generateDemoData}
                                            block
                                        >
                                            Generate
                                        </Button>
                                        <Text type="secondary" style={{fontSize: 12}}>
                                            Creates realistic, pre-tagged ITSM ticket texts covering all
                                            PII entity types. Perfect to demo tagging and model training
                                            without any customer data.
                                        </Text>
                                    </Space>
                                </Card>
                            </div>
                        </div>
                    )
                    : (
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 12,
                            flexWrap: "wrap",
                            marginBottom: 12,
                        }}>
                            <Button
                                onClick={() => {
                                    let filename;
                                    Modal.info({
                                        title: 'Enter the filename',
                                        content: <Input
                                            placeholder={"Filename"}
                                            onChange={(e) => {
                                                filename = e.target.value
                                            }}
                                        />,
                                        onOk: () => {
                                            dispatch(saveTrainingData({
                                                userManager,
                                                data: {
                                                    filename,
                                                    data: JSON.stringify(data.map(row => {
                                                        return {text: row[selectedColumn], tags: row.tags}
                                                    }))
                                                }
                                            }))
                                            message.success("Successfully Saved")
                                        }
                                    })
                                }}
                                icon={<SaveOutlined/>}
                                type="primary"
                            >
                                Save
                            </Button>

                            <Popconfirm
                                title={selectedRowKeys.length > 0
                                    ? `Auto-tag ${selectedRowKeys.length} selected row(s)? Existing tags in them will be replaced.`
                                    : "Auto-tag all untagged rows?"}
                                onConfirm={autoTagRows}
                                okText="Start"
                            >
                                <Button icon={<ThunderboltOutlined/>} loading={autoTagging}>
                                    Auto-Tag
                                </Button>
                            </Popconfirm>
                            {autoTagging && autoTagProgress !== null && (
                                <Progress percent={autoTagProgress} size="small" style={{width: 140}}/>
                            )}

                            <div style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                            }}>
                                <Text type="secondary">Column</Text>
                                <Select
                                    value={selectedColumn}
                                    onChange={handleColumnSelect}
                                    style={{minWidth: 150}}
                                >
                                    {data.length > 0 &&
                                        Object.keys(data[0]).map((colName) => {
                                            return <Option key={colName}>{colName}</Option>;
                                        })}
                                </Select>
                            </div>

                            <Space.Compact>
                                <Input
                                    placeholder="Filter using regex..."
                                    onChange={handleSearch}
                                    style={{width: 200}}
                                />
                                <Button onClick={() => setFilterResults(!filterResults)}>Filter</Button>
                            </Space.Compact>
                        </div>
                    )
                }

                {data.length > 0 && (
                    <Card size="small" style={{marginBottom: 16}}>
                        <Space split={<span style={{color: "#d9d9d9"}}>|</span>}>
                            {(file || tfilename) &&
                                <Text type="secondary">File: {file?.name || tfilename}</Text>}
                            <Text type="secondary">{data.length} rows</Text>
                            <Text type="secondary">{Object.keys(data[0] || {}).length} columns</Text>
                            {stat.taggedRows !== undefined && (
                                <Text type="secondary">{stat.taggedRows} / {stat.rows} tagged</Text>
                            )}
                        </Space>
                        {stat.rows > 0 && (
                            <Progress
                                percent={Math.round((stat.taggedRows / stat.rows) * 100)}
                                size="small"
                                status="active"
                                style={{marginTop: 4}}
                            />
                        )}
                    </Card>
                )}

                {data.length > 0 && tags.length > 0 && (
                    <Card size="small" style={{marginBottom: 16}}>
                        <div style={{display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap"}}>
                            <Text type="secondary" style={{fontSize: 13, marginRight: 4}}>Active Tag:</Text>
                            {tags.length > 8 && (
                                <Input
                                    placeholder="Filter tags..."
                                    allowClear
                                    value={tagFilter}
                                    onChange={(e) => setTagFilter(e.target.value)}
                                    style={{width: 140, flexShrink: 0}}
                                    size="small"
                                />
                            )}
                            {tags
                                .map((tag, i) => ({tag, i}))
                                .filter(({tag}) => !tagFilter || tag.tag.toLowerCase().includes(tagFilter.toLowerCase()))
                                .map(({tag, i}) => {
                                    const tagKey = `TAG-${i}`;
                                    const isActive = activeTag === tagKey;
                                    return (
                                        <div
                                            key={tagKey}
                                            onClick={() => dispatch(setActiveTag(tagKey))}
                                            style={{
                                                cursor: "pointer",
                                                opacity: isActive ? 1 : 0.5,
                                                transform: isActive ? "scale(1.05)" : "scale(1)",
                                                transition: "all 0.15s",
                                                outline: isActive ? `2px solid ${tag.color}` : "2px solid transparent",
                                                outlineOffset: 2,
                                                borderRadius: 4,
                                            }}
                                        >
                                            <Tag tagName={tag.tag} color={tag.color} index={i} closable={false}/>
                                        </div>
                                    );
                                })}
                        </div>
                        <Text type="secondary" style={{fontSize: 12, marginTop: 6, display: "block"}}>
                            Select a tag, then click or highlight text in a row to annotate it.
                        </Text>
                    </Card>
                )}

                <Table dataSource={tableData} columns={columns} rowSelection={rowSelection}/>
            </ManyosSpinner>
        </div>
    )
}

export default connect(select)(PrepData)
